<template>
  <div class="s-canvas">
    <canvas
        id="s-canvas"
        :width="contentWidth"
        :height="contentHeight"
    ></canvas>
  </div>
</template>
<script>
export default {
  name: 'SIdentify',
  props: {
    identifyCode: {
      type: String,
      default: '1234',
    },
    fontSizeMin: {
      type: Number,
      default: 20,
    },
    fontSizeMax: {
      type: Number,
      default: 40,
    },
    backgroundColorMin: {
      type: Number,
      default: 180,
    },
    backgroundColorMax: {
      type: Number,
      default: 240,
    },
    colorMin: {
      type: Number,
      default: 50,
    },
    colorMax: {
      type: Number,
      default: 160,
    },
    lineColorMin: {
      type: Number,
      default: 40,
    },
    lineColorMax: {
      type: Number,
      default: 180,
    },
    dotColorMin: {
      type: Number,
      default: 0,
    },
    dotColorMax: {
      type: Number,
      default: 255,
    },
    contentWidth: {
      type: Number,
      default: 112,
    },
    contentHeight: {
      type: Number,
      default: 45,
    },
  },
  methods: {
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 生成一个随机的颜色
    randomColor(min, max) {
      let r = this.randomNum(min, max)
      let g = this.randomNum(min, max)
      let b = this.randomNum(min, max)
      return 'rgb(' + r + ',' + g + ',' + b + ')'
    },
    drawPic() {
      let canvas = document.getElementById('s-canvas')
      let ctx = canvas.getContext('2d')
      // 先清空画布
      ctx.clearRect(0, 0, this.contentWidth, this.contentHeight)
      ctx.textBaseline = 'bottom'
      // 绘制背景
      ctx.fillStyle = this.randomColor(
          this.backgroundColorMin,
          this.backgroundColorMax
      )
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)
      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }
      //this.drawLine(ctx)
      this.drawDot(ctx)
    },
    drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax)

      // 动态字体大小（根据画布高度限制最大字号）
      const maxFontSize = Math.min(this.contentHeight - 10, this.fontSizeMax)
      const fontSize = this.randomNum(Math.max(this.fontSizeMin, 24), maxFontSize)
      ctx.font = `${fontSize}px SimHei`

      // 计算字符实际宽度
      const metrics = ctx.measureText(txt)
      const charWidth = metrics.width

      // 动态间距计算（考虑字符实际宽度）
      const totalUsableWidth = this.contentWidth - 40 // 保留左右各20px边距
      const step = (totalUsableWidth - (charWidth * this.identifyCode.length)) / (this.identifyCode.length + 1)

      // 字符位置计算（增加左右边距）
      const baseX = 20 + (step * (i + 1)) + (charWidth * i)
      const x = baseX + this.randomNum(-step / 2, step / 2) // 在步长范围内随机偏移

      // 垂直位置计算（考虑字体下延部分）
      const verticalPadding = 5
      const minY = fontSize + verticalPadding
      const maxY = this.contentHeight - verticalPadding
      const y = this.randomNum(minY, maxY)

      // 限制旋转角度（±25度）
      const deg = this.randomNum(-25, 25)

      // 边界检测（考虑旋转后的绘制范围）
      const safeMargin = charWidth * Math.abs(Math.sin(deg * Math.PI / 180))
      if (x - safeMargin < 20 || x + charWidth + safeMargin > this.contentWidth - 20) {
        return this.drawText(ctx, txt, i) // 重新生成位置
      }

      ctx.save()
      ctx.translate(x, y)
      ctx.rotate((deg * Math.PI) / 180)
      ctx.textBaseline = 'alphabetic' // 修改基线对齐方式
      ctx.fillText(txt, 0, 0)
      ctx.restore()
    },
    drawLine(ctx) {
      // 绘制干扰线
      for (let i = 0; i < 8; i++) {
        ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax)
        ctx.beginPath()
        ctx.moveTo(
            this.randomNum(0, this.contentWidth),
            this.randomNum(0, this.contentHeight)
        )
        ctx.lineTo(
            this.randomNum(0, this.contentWidth),
            this.randomNum(0, this.contentHeight)
        )
        ctx.stroke()
      }
    },
    drawDot(ctx) {
      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.randomColor(50, 200)
        ctx.beginPath()
        ctx.arc(
            this.randomNum(0, this.contentWidth),
            this.randomNum(0, this.contentHeight),
            1,
            0,
            2 * Math.PI
        )
        ctx.fill()
      }
    },
  },
  watch: {
    identifyCode() {
      this.drawPic()
    },
  },
  mounted() {
    this.drawPic()
  },
}
</script>